import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { PROJECTS_FILTERS_CONTEXTS_NAMES } from '../contexts';
import useSettingsService from 'components/hooks/useSettingsService';

const mapContextToFF = {
  [PROJECTS_FILTERS_CONTEXTS_NAMES.PROJECT_PROGRESSION]:
    FEATURE_FLAGS_NAMES.isTreeHierarchyFiltersEnabled,
  [PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION]:
    FEATURE_FLAGS_NAMES.isTreeHierarchyFiltersEnabled,
  [PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING]:
    FEATURE_FLAGS_NAMES.isTreeHierarchyFiltersEnabled
};

const useIsTreeHierarchyEnabled = Context => {
  const ffName = mapContextToFF[Context?.name];
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isTreeHierarchyByContextEnabled = getSettingOrDefinitionValue({
    name: ffName
  });

  return !!isTreeHierarchyByContextEnabled;
};

export default useIsTreeHierarchyEnabled;
